import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AddRoom from "./AddRoom";
import { getRooms } from "../../apis/room";
import { Pagination, PaginationProps } from "antd";
import CommonPagination from "../../components/CommanPagination";

interface Room {
  id: number;
  name: string;
  floor: string;
  status: "available" | "occupied" | "maintenance";
  roomType?: {
    id: number;
    name: string;
    price_per_hour: string;
    price_per_day: string;
  };
}

const RoomsList = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [rooms, setRooms] = useState<Room[]>([]);
  const [loading, setLoading] = useState(true);
  const [meta, setMeta] = useState<any>({}); 

  const fetchRooms = async (params = { page: 1, per_page: 10 }) => {
    try {
      setLoading(true);
      const response: any = await getRooms(params);
      setRooms(response?.data || []);
      // setMeta(response.meta || {});
      setMeta({
      currentPage: response.currentPage,
      perPage: response.perPage,
      total: response.total,
    });
    } catch (error) {
      console.error("Error fetching rooms:", error);
      setRooms([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  const handleRoomAdded = () => {
    fetchRooms({ page: meta.current_page || 1, per_page: meta.per_page || 10 });
  };

  // const onPaginationChange: PaginationProps["onChange"] = (page, pageSize) => {
  //   fetchRooms({ page, per_page: pageSize });
  // };
  const onPaginationChange = (page: number, pageSize?: number) => {
  fetchRooms({ page, per_page: pageSize || 10 }); 
};

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Rooms List
          </h1>
          <p className="mt-2 text-sm text-gray-700">List of all rooms.</p>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => setOpenModal(true)}
            className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Add Room
          </button>

          <button
            type="button"
            className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
          >
            Export
          </button>
        </div>
      </div>

      <AddRoom
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSuccess={handleRoomAdded}
      />

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Room ID
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                       Name
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                       Type
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Floor
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Status
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-200">
                  {loading ? (
                    <tr>
                      <td
                        colSpan={6}
                        className="py-4 text-center text-sm text-gray-500"
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : rooms.length === 0 ? (
                    <tr>
                      <td
                        colSpan={6}
                        className="py-4 text-center text-sm text-gray-500"
                      >
                        No rooms found
                      </td>
                    </tr>
                  ) : (
                    rooms.map((room) => (
                      <tr key={room.id}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {room.id}
                        </td>

                        <td className="py-4 px-3 text-sm text-gray-700">
                          {room.name}
                        </td>

                        <td className="py-4 px-3 text-sm text-gray-700">
                          {room.roomType?.name || "N/A"}
                        </td>

                        <td className="py-4 px-3 text-sm text-gray-700">
                          {room.floor}
                        </td>

                        <td
                          className={`py-4 px-3 text-sm font-medium capitalize ${
                            room.status === "available"
                              ? "text-green-600"
                              : room.status === "occupied"
                              ? "text-yellow-600"
                              : "text-red-600"
                          }`}
                        >
                          {room.status}
                        </td>

                        <td className="py-4 px-3 text-sm text-gray-700">
                          <button className="px-3 py-2 text-sm text-white bg-primary rounded hover:bg-hover">
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            {/* <div className="flex justify-end pt-5">
              <Pagination
                current={meta.current_page || 1}
                pageSize={meta.per_page || 10}
                total={meta.total || 0}
                onChange={onPaginationChange}
              />
            </div> */}
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomsList;
